import client from '../api/client.ts';

export type TopHour = { hour: string; count: number };
export type TopJobTitle = { title: string; count: number };

export type OverviewMetrics = {
  bookings_today: number;
  bookings_week: number;
  show_rate: number; // 0..1
  revenue_deposits: number;
  top_hours: TopHour[];
  top_job_titles: TopJobTitle[];
};

export const getOverview = async (from?: string, to?: string): Promise<OverviewMetrics> => {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  const qs = params.toString();
  const url = '/api/v1/admin/metrics/overview' + (qs ? `?${qs}` : '');
  const { data } = await client.get(url);
  return data as OverviewMetrics;
};

export const downloadOverviewCsv = async (from?: string, to?: string) => {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  params.set('export', 'csv');
  const url = '/api/v1/admin/metrics/overview?' + params.toString();
  const res = await client.get(url, { responseType: 'blob' as any });
  return res.data as Blob;
};

export const downloadTopHoursCsv = async (from?: string, to?: string) => {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  params.set('export', 'csv');
  const url = '/api/v1/admin/metrics/top-hours?' + params.toString();
  const res = await client.get(url, { responseType: 'blob' as any });
  return res.data as Blob;
};

export const downloadTopJobTitlesCsv = async () => {
  const url = '/api/v1/admin/metrics/top-job-titles?export=csv';
  const res = await client.get(url, { responseType: 'blob' as any });
  return res.data as Blob;
};

export default { getOverview, downloadOverviewCsv, downloadTopHoursCsv, downloadTopJobTitlesCsv };


